import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  { title: 'Home', isLink: true, href: '/' },
  { title: 'Route Tool', isLink: false },
  { title: 'Templates', isLink: false },
];

const Title: PageTitle = {
  title: 'Download Templates',
};

export { Breadcrumbs, Title };
